import { InfoOutlined as MuiInfoIcon } from "@mui/icons-material";
import { SvgIconProps } from "@mui/material/SvgIcon";

export default function InfoIcon(props: SvgIconProps) {
  return (
    <MuiInfoIcon
      {...props}
      sx={{
        color: "#000",
        fontSize: "1.25rem",
        marginLeft: 1,
        width: 18,
        height: 18,
      }}
    />
  );
}
